<template>
  <div class="loan" :class="{ 'is-overlapped': isHeaderOverlapped }">
    <!--头部-->
    <Navbar
      title="借款"
      :leftArrow="false"
      :isNotify="false"
      :isCustomerService="false"
      :isSpecialBack="true"
      @goBack="goBack"
    >
      <template #right>
        <div class="right-content" @click="qimoChatClick">
          <img
            class="customerServiceIcon"
            src="@/assets/style/customer-service-icon.png"
            alt=""
          />
        </div>
      </template>
    </Navbar>
    <!--内容区域-->
    <div class="content">
      <div ref="contentSentinel" class="content-sentinel"></div>
      <!--借款卡片-->
      <LoanCard :pendingPlan="pendingPlan" />
      <!--还款计划-->
      <repaymentPlan :pendingPlan="pendingPlan" />
    </div>
    <div class="block"></div>
    <!--立即借款按钮-->
    <div class="footer-wrap">
      <div class="footer-content">
        <!--借款协议-->
        <protocolField
          v-model="isChecked"
          routerName="loan"
          protocol="loan"
          protocolType="5"
        />
        <div class="btn" @click="handleSubmitClick">立即借款</div>
      </div>
    </div>
    <Popup
      ref="popup"
      message="请先阅读并同意相关协议"
      confirmText="同意并继续"
      cancelText="不同意"
      @confirm="handleConfirm"
    />
    <Popup
      ref="popupBank"
      message="请先绑定收款账户"
      confirmText="去绑卡"
      cancelText="取消"
      @confirm="handleBindBank"
    />
    <Popup
      ref="popup3"
      message="资质不匹配，系统为您推荐了其他产品，快去看看吧"
      confirmText="去查看"
      cancelText="返回首页"
      title="资质不匹配"
      @confirm="handleToOtherProduct"
      @cancel="gotoHome"
    />
  </div>
</template>

<script>
import Navbar from "@/components/navbar/index.vue";
import LoanCard from "@/components/loan/loanCard.vue";
import repaymentPlan from "@/components/loan/repaymentPlan.vue";
import protocolField from "@/components/protocolField/index.vue";
import {
  createLoanOrder,
  getPendingPlan,
  getBankCardList,
  getBorrowProtocol,
  sign,
} from "@/api/index.js";
import Popup from "@/components/Popup/index.vue";
export default {
  name: "Loan",
  components: {
    Navbar,
    LoanCard,
    repaymentPlan,
    protocolField,
    Popup,
  },
  data() {
    return {
      pendingPlan: {},
      isChecked: false,
      isHeaderOverlapped: false,
      routerName: "",
      isNavigatingAway: false,
      isSubmitting: false, // 新增：防重复点击
    };
  },
  beforeRouteEnter(to, from, next) {
    console.log(to, from);

    next((vm) => {
      if (from.name == "Home" || from.name == "orderList") {
        vm.isChecked = false;
      } else {
        vm.routerName = from.name;
        vm.isNavigatingAway = false;
      }
    });
  },
  activated() {
    getPendingPlan().then((res) => {
      if (res.code === 2000) {
        this.pendingPlan = res.data;
      } else {
        this.$toast(res.msg || res.message || "获取借款计划失败");
      }
    });
    //获取收款银行列表
    getBankCardList({ pageNumber: 1, pageSize: 100 }).then((res) => {
      if (res.code === 2000) {
        res.data.recordList.forEach((item) => {
          if (item.defaultState == 1) {
            this.$store.commit("setBankInfo", item);
          }
        });
        this.$store.commit("setBankList", res.data.recordList || []);
      }
    });
    this.$nextTick(() => {
      this.initHeaderOverlapObserver();
    });
  },
  beforeDestroy() {
    this._contentObserver?.disconnect();
    this._contentObserver = null;
  },
  methods: {
    qimoChatClick() {
      if (process.env.VUE_APP_ENV === "productionApp") {
        this.$JSBridge.send("serviceType", { type: "8" });
      } else {
        const fromUrl = window.location.href;
        const urlTitle = document.title;
        const nickName = this.userInfo?.username || "";
        const clientId = localStorage.getItem("phone")
          ? `phone_${localStorage.getItem("phone")}`
          : "";
        window.open(
          `https://ykf-weixin01.7moor.com/wapchat.html?accessId=f12bce20-49ee-11f1-aea3-c5caf3f64abe&fromUrl=${fromUrl}&urlTitle=${urlTitle}&language=ZHCN&nickName=${nickName}&clientId=${clientId}`,
        );
      }
    },
    //返回首页
    gotoHome() {
      this.$refs.popup3.hidePopup();
      this.$router.push({
        name: "Home",
      });
    },
    //去其他产品
    handleToOtherProduct() {},
    goBack() {
      this.$router.push({
        name: "Home",
      });
    },
    handleBindBank() {
      this.$refs.popupBank.hidePopup();
      this.$nextTick(() => {
        this.$store.state.bankCardBindingFlag = "1";
        this.$router.push({
          name: "bankCardBinding",
        });
      });
    },
    //同意并继续登录
    handleConfirm() {
      this.isChecked = true;
    },
    initHeaderOverlapObserver() {
      const sentinelEl = this.$refs.contentSentinel;
      if (!sentinelEl || typeof IntersectionObserver === "undefined") return;

      const rootEl = this.$el;
      this._contentObserver?.disconnect();
      this._contentObserver = new IntersectionObserver(
        ([entry]) => {
          this.isHeaderOverlapped = entry ? !entry.isIntersecting : false;
        },
        {
          root: rootEl,
          threshold: 0,
          rootMargin: `-${46}px 0px 0px 0px`,
        },
      );
      this._contentObserver.observe(sentinelEl);
    },
    async handleSubmitClick() {
      if (this.isSubmitting) return; // 正在提交中，直接返回
      this.isSubmitting = true; // 上锁
      try {
        if (!this.$store.state.bankInfo.bankName) {
          this.$refs.popupBank.showPopup();
          return;
        }
        if (!this.isChecked) {
          this.$refs.popup.showPopup();
          return;
        }
        //借款前需先生成借款协议信息
        await getBorrowProtocol({
          type: 5,
          bankCardId:
            this.$store.state.receivedBank.id || this.$store.state.bankInfo.id,
          borrowPurpose: this.$store.state.borrowPurpose || "个人消费",
        }).then(() => {});
        //调用创建借款订单接口
        await createLoanOrder({
          borrowPurpose: this.$store.getters.borrowPurpose || "个人消费",
          accountBankCardId:
            this.$store.state.receivedBank.id || this.$store.state.bankInfo.id,
        }).then(async (res) => {
          if (res.code === 2000) {
            this.$toast("提交成功");
            this.$store.commit("setReceivedBank", {});
            await sign({
              configIds: this.$store.state.agreementList.map(
                (item) => item.configId,
              ),
            });
            this.$router.replace({
              path: "/orderDetails",
              query: {
                borrowOrderId: res.data,
              },
            });
          } else {
            if (res.code == 10010) {
              this.$refs.popup3.showPopup();
              return;
            }
            this.$toast(res.msg || res.message || "借款失败");
          }
        });
      } finally {
        this.isSubmitting = false; // 无论成功失败，最终都解锁
      }
    },
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo;
    },
  },
};
</script>

<style scoped lang="scss">
.loan {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  overflow-y: auto;
  background: linear-gradient(
    180deg,
    #0d63ef 10%,
    #1d70f7 28.56%,
    rgba(211, 227, 253, 0.2) 67.17%,
    rgba(255, 255, 255, 0) 100%
  );
}
.loan.is-overlapped {
  ::v-deep(.van-nav-bar) {
    background: #0d63ef !important;
  }
  ::v-deep(.van-nav-bar__title) {
    color: #fff;
  }
}
::v-deep(.van-nav-bar) {
  background: transparent !important;
}
::v-deep(.van-nav-bar__title) {
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 18px;
  color: #fff;
}
.left-content {
  display: flex;
  flex-direction: column;
  font-size: 18px;
  font-family: "Regular";
  color: #fff;
  align-items: center;
  img {
    width: 24px;
    height: 24px;
  }
}
.content {
  position: relative;
  padding: 0px 16px;
}
.content-sentinel {
  position: absolute;
  top: 0;
  left: 0;
  width: 1px;
  height: 1px;
}
.block {
  height: 130px;
  background: #f4f4f4;
  width: 100%;
}
.notifyIcon {
  width: 24px;
  height: 24px;
}
.customerServiceIcon {
  width: 24px;
  height: 24px;
  padding-left: 16px;
}
.footer-wrap {
  height: 130px;
  background: #ffffff;
  box-shadow: 0px -2px 19px 0px rgba(0, 0, 0, 0.15),
    0px 1px 7px 0px rgba(0, 0, 0, 0.15);
  border-radius: 12px 12px 0px 0px;
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  .footer-content {
    padding: 0px 28px;
    .btn {
      width: 100%;
      height: 50px;
      background: #1d70f7;
      border-radius: 30px;
      font-size: 18px;
      font-family: "Regular";
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 20px;
    }
  }
}
.block {
  height: 130px;
  width: 100%;
}
</style>
